<!--begin::Main-->
<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
    [fullScreen]="true">
    <span class="loader">
        <img width="150px" src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
    <!--begin::Content wrapper-->
    <div class="d-flex flex-column flex-column-fluid">

        <!--begin::Toolbar-->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <!--begin::Toolbar container-->
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <!--begin::Page title-->
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <!--begin::Title-->
                    <div class="d-flex align-items-center">
                        <h1 class="page-heading mt-0 mb-0"> <svg width="41" height="44" viewBox="0 0 41 44" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_615_2549)">
                                    <path
                                        d="M15.1976 30.5794C16.2337 29.2326 17.8276 28.4404 19.5013 28.4404H25.7973C26.7537 28.4404 27.6303 28.0443 28.2679 27.4105L36.0782 19.3298C36.3173 19.0922 36.3173 18.6168 36.0782 18.3792C35.8391 18.1415 35.4406 18.0623 35.2016 18.2207L27.8694 22.5779C27.6303 23.7663 26.5943 24.7169 25.3191 24.7169H17.987C17.5885 24.7169 17.19 24.4 17.19 23.9247C17.19 23.5286 17.5885 23.1325 17.987 23.1325H25.3191C25.877 23.1325 26.3552 22.6572 26.3552 22.1026C26.3552 21.5481 25.877 21.0727 25.3191 21.0727H14.1616C12.5676 21.0727 11.0534 21.7857 10.097 22.9741L7.30762 26.3014L14.4803 31.6885L15.1976 30.5794Z"
                                        fill="#265D91" />
                                    <path
                                        d="M14.8784 33.9066L14.1611 33.352L6.27108 27.4104L4.75684 29.3117L13.3641 35.8079L14.8784 33.9066Z"
                                        fill="#265D91" />
                                    <path
                                        d="M9.93705 17.2701H30.8177C31.4552 17.2701 31.9334 16.7948 31.9334 16.161V10.1401C28.108 11.4869 24.2028 12.1999 20.3773 12.1999C16.5519 12.1999 12.6467 11.4869 8.82129 10.1401V16.161C8.82129 16.7948 9.29947 17.2701 9.93705 17.2701Z"
                                        fill="#265D91" />
                                    <path
                                        d="M31.9334 8.15949V4.59451C31.9334 3.96073 31.4552 3.4854 30.8177 3.4854H25.7967V1.10874C25.7967 0.633412 25.3983 0.158081 24.8404 0.158081H15.9143C15.4361 0.158081 14.958 0.55419 14.958 1.10874V3.4854H9.93705C9.29947 3.4854 8.82129 3.96073 8.82129 4.59451V8.15949C16.4722 11.0115 24.2825 11.0115 31.9334 8.15949ZM16.791 1.98018H23.884V3.40618H16.791V1.98018ZM19.1819 6.97116C19.1819 6.25817 19.7398 5.62439 20.3773 5.62439C21.0149 5.62439 21.5728 6.17894 21.5728 6.97116C21.5728 7.68416 21.0149 8.31793 20.3773 8.31793C19.7398 8.31793 19.1819 7.68416 19.1819 6.97116Z"
                                        fill="#265D91" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_615_2549" x="0.756836" y="0.158081" width="39.501"
                                        height="43.6498" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix"
                                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix"
                                            result="effect1_dropShadow_615_2549" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_615_2549"
                                            result="shape" />
                                    </filter>
                                </defs>
                            </svg>

                            Nos offres d’emploi
                        </h1>
                        <!--begin::Menu-->
                    </div>
                    <!--end::Title-->
                    <!--begin::Breadcrumb-->
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">
                            <a routerLink="/accueil" class="text-muted ">Accueil</a>
                          </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted"> <a class="text-muted " routerLink="/offres-emploi/liste-offres-emploi">Nos offres d’emploi</a></li>
                        <li class="breadcrumb-item">
                            <span class="bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <!--end::Item-->
                        <!--begin::Item-->
                        <li class="breadcrumb-item text-muted">Créer une offre d’emploi</li>
                        <!--end::Item-->
                    </ul>
                    <!--end::Breadcrumb-->
                </div>
                <!--end::Page title-->
                <!--begin::Actions-->

                <!--end::Actions-->
            </div>
            <!--end::Toolbar container-->
        </div>
        <!--end::Toolbar-->

        <!--begin::Content-->

        <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
            <!--begin::Content container-->
            <div id="kt_app_content_container" class="app-container container-fluid">
                <!--begin::Card-->
                <div class=" card content">

                    <!--begin::Card header-->
                    <div class="container-content">
                        <div class="d-flex flex-wrap header-grid align-items-center">
                            <div class="section_title">
                                <h1 class="section-heading">Créer une offre d’emploi</h1>
                            </div>
                        </div>
                        <form [formGroup]="formjoboffer">
                            <div class="card-body pt-0">
                                <div class="row">
                                    <div class="col-sm-6 mb-5 tools">
                                          <label for="nom">Poste <span class="start-required">*</span></label>
                                        <input type="text" formControlName="name" id="poste" class="form-control mb-3"
                                            placeholder="Poste">
                                             <div *ngIf="
                                                formjoboffer.get('name')?.hasError('required') &&
                                                formjoboffer.get('name')?.touched
                                              " class="text-danger">
                                              Le champ "Poste" est obligatoire .
                                            </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                         <label for="nom">Années d'experience <span class="start-required">*</span></label>
                                        <input type="number"
                                            formControlName="years_of_experience" id="annee" min="0" oninput="validity.valid||(value='0');"
                                            placeholder="Années d'experience" class="form-control mb-3">
                                        <!-- <app-feild-error [control]="formjoboffer.get('years_of_experience')"
                                            [controlName]="'years_of_experience'"></app-feild-error> -->
                                            <div *ngIf="
                                                formjoboffer.get('years_of_experience')?.hasError('required') &&
                                                formjoboffer.get('years_of_experience')?.touched
                                              " class="text-danger">
                                              Le champ "Années d'experience" est obligatoire .
                                            </div>
                                    </div>
                                    <div class="col-sm-6 mb-5">
                                         <label for="nom">Type de poste</label>
                                        <ng-select [items]="poste" bindLabel="name" bindValue="id"  [notFoundText]="'Aucun élément trouvé'"
                                            formControlName="post_type" [placeholder]="'Type de poste'" autoComplete>
                                        </ng-select>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="nom">Type de contrat</label>
                                        <ng-select [items]="contrat" bindLabel="name" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                                            formControlName="contract_type" [multiple]="true"
                                            [placeholder]="'Type de contrat'" autoComplete>
                                        </ng-select>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                         <label for="nom">Salaire</label>
                                        <div class="combined-input">
                                            <input type="number" min="0" oninput="validity.valid||(value='0');"
                                                formControlName="salary" id="Salaire" class="form-control"
                                                placeholder="Salaire &euro; ">
                                            <div class="euro">
                                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                        fill="#4B4B4B" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 mb-5 tools">
                                        <label for="nom">TJM</label>
                                        <div class="combined-input">
                                            <input type="number" min="0" oninput="validity.valid||(value='0');"
                                                formControlName="tjm" id="TJM" class="form-control "
                                                placeholder="TJM &euro; ">
                                            <div class="euro">
                                                <svg width="11" height="11" viewBox="0 0 11 11" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                                                        fill="#4B4B4B" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 mb-5 tools">
                                        <!-- <ng-select [items]="paysList" (change)="onCountryChange($event)"
                                            formControlName="country" bindLabel="name" bindValue="name"
                                            [placeholder]="'Pays *'" [notFoundText]="'Aucun élément trouvé'" autoComplete>
                                        </ng-select> -->
                                         <label for="nom">Pays <span class="start-required">*</span></label>
                                        <ng-select (change)="onCountryChangeSearch($event)" [items]="paysList" [multiple]="true"
                                        id="pays_destinataire" bindLabel="name" bindValue="name" [placeholder]="'Pays'"
                                        autoComplete formControlName="country"  [notFoundText]="'Aucun élément trouvé'" >
                                        <ng-template ng-optgroup-tmp let-item="item">
                                          {{ item.name || "Unnamed group" }}
                                        </ng-template>
                                      </ng-select>
                                            <div *ngIf="
                                                formjoboffer.get('country')?.hasError('required') &&
                                                formjoboffer.get('country')?.touched
                                              " class="text-danger">
                                              Le champ "Pays" est obligatoire .
                                            </div>
                                    </div>
                                    <div class="col-sm-6 mb-5 tools">
                                         <label for="nom">Ville</label>
                                        <ng-select  [items]="stateList" [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null" [multiple]="true"
                                        (change)="onMobilityChange('add')" id="mobilite" bindLabel="name"
                                        formControlName="city" 
                                        [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'Ville '" autoComplete>
                                        </ng-select>
                                    </div>
                                    <div class="col-sm-6 mb-5">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" formControlName="profile_abroad"
                                                type="checkbox" value="" id="flexCheckChecked" checked />
                                            <label class="form-check-label" for="flexCheckChecked">
                                                Possibilité profil à l'étranger
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-5">
                                        <div class="form-check form-check-custom form-check-solid" *ngIf="showPasseportTalent" >
                                            <input class="form-check-input" type="checkbox" value=""
                                                formControlName="passeport_talent" id="flexCheckChecked1" checked />
                                            <label class="form-check-label" for="flexCheckChecked1">
                                                Passeport talent
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 mb-5">
                                        <div class="mb-10">
                                             <label for="nom">Compétences <span class="start-required">*</span></label>
                                            <ng-select [items]="skillsList" bindLabel="name_FR" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                                                formControlName="skills" [multiple]="true" id="skillsList"
                                                [placeholder]="'Compétences *'" autoComplete>
                                            </ng-select>
                                            <span class="requirements mb-3">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <g clip-path="url(#clip0_379_198)">
                                                    <path
                                                      d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                                                      fill="#2b5d8f" />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_379_198">
                                                      <rect width="16" height="16" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                &nbsp;<span style="padding-top: 3px;font-size:12px">Si vous n'ajoutez pas de compétence, vous ne pourrez pas créer de test par la suite.</span> 
                                            </span><br />
                                            <!-- <app-feild-error [control]="formjoboffer.get('skills')"
                                                [controlName]="'skills'"></app-feild-error> -->
                                                <div *ngIf="
                                                formjoboffer.get('skills')?.hasError('required') &&
                                                formjoboffer.get('skills')?.touched
                                              " class="text-danger">
                                              Le champ "Compétences" est obligatoire .
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 autres mb-5">
                                             <label for="nom">Autres compétences</label>
                                            <mat-chip-grid #chipGrid aria-label="Enter skill">
                                              <mat-chip-row *ngFor="let skill of addSkills" (removed)="remove(skill)"
                                                [editable]="true" (edited)="edit(skill, $event)" >
                                                {{ skill.name }}
                                                <button matChipRemove [attr.aria-label]="'remove ' + skill.name">
                                                  <mat-icon>x</mat-icon>
                                                </button>
                                              </mat-chip-row>  
                                              <input  placeholder="Autres compétences (séparées par  , )" (blur)="isFormatCompetenceAdmin=false"
                                                [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="
                                                  separatorKeysCodes
                                                " [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" />
                                            </mat-chip-grid>
                                        </div>
                                    <div class="col-sm-6 tools mb-5">
                                         <label for="nom">Disponibilité</label>
                                        <ng-select [items]="disponibilite" formControlName="availability" [notFoundText]="'Aucun élément trouvé'"
                                            bindLabel="name" bindValue="id" [placeholder]="'Disponibilité'"
                                            autoComplete>
                                        </ng-select>
                                        <!-- <app-feild-error [control]="formjoboffer.get('availability')"
                                            [controlName]="'availability'"></app-feild-error> -->
                                            <div *ngIf="
                                                formjoboffer.get('availability')?.hasError('required') &&
                                                formjoboffer.get('availability')?.touched
                                              " class="text-danger">
                                              Le champ "Disponibilité" est obligatoire .
                                            </div>
                                    </div>
                                     <div class="col-sm-12 mb-5 tools">
                                          <div class="desc tools mb-10">
                                        <label for="nom">Description <span class="start-required">*</span></label>
                                            <quill-editor  [placeholder]="'Description *'" 
                                            (onContentChanged)="onContentChange($event)"
                                            formControlName="description" [modules]="{ toolbar: toolbarOptions }" style="width: 100%;" ></quill-editor>  
                                       <div *ngIf="
                                                formjoboffer.get('description')?.hasError('required') &&
                                                formjoboffer.get('description')?.touched
                                              " class="text-danger">
                                              Le champ "Description" est obligatoire .
                                            </div>
                                    </div>
                                     </div>
                                </div>
                                <div class="row">
                                    <div class="actions add">
                                         <a class="annuler cursor-pointer" routerLink="/offres-emploi/liste-offres-emploi">Annuler</a>
                                        <button  class="confirmer"  (click)="createjoboffer()" [disabled]="formjoboffer.invalid">
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                             d="M11.4758 18.5502L8.44445 10.1374C8.3936 9.99568 8.3859 9.84199 8.42233 9.69585C8.45877 9.54972 8.53768 9.41773 8.64906 9.31666L10.4224 7.53834C10.4123 7.30564 10.4731 7.07538 10.5967 6.87816C10.7203 6.68093 10.9008 6.52609 11.1142 6.43421C11.3276 6.34232 11.5639 6.31775 11.7916 6.36374C12.0193 6.40974 12.2276 6.52413 12.389 6.69171C12.5503 6.8593 12.6569 7.07214 12.6947 7.30196C12.7325 7.53178 12.6997 7.76769 12.6006 7.97835C12.5014 8.189 12.3408 8.36443 12.1398 8.48131C11.9389 8.59819 11.7073 8.65099 11.4758 8.6327L10.0359 10.0766L12.173 16.012L17.0382 1.9754L3.04112 6.85438L6.26948 7.99432C6.46242 8.06588 6.61913 8.21136 6.70511 8.39878C6.79109 8.58619 6.79931 8.80019 6.72796 8.99368C6.65661 9.18717 6.51153 9.34432 6.32465 9.43054C6.13776 9.51677 5.92437 9.52501 5.73142 9.45346L0.509966 7.56114C0.36106 7.50946 0.231921 7.41252 0.140519 7.2838C0.049118 7.15508 0 7.00099 0 6.84298C0 6.68496 0.049118 6.53087 0.140519 6.40216C0.231921 6.27344 0.36106 6.17649 0.509966 6.12481L18.0007 0.0450919C18.136 -0.00387194 18.2825 -0.013182 18.4229 0.0182501C18.5634 0.0496822 18.692 0.120557 18.7937 0.222589C18.8955 0.32462 18.9661 0.45359 18.9975 0.594419C19.0288 0.735247 19.0195 0.882115 18.9707 1.01785L12.9081 18.5578C12.8557 18.7069 12.7584 18.8359 12.6296 18.9269C12.5007 19.0179 12.3468 19.0663 12.1892 19.0655C12.0316 19.0646 11.8782 19.0146 11.7504 18.9222C11.6225 18.8299 11.5265 18.6998 11.4758 18.5502Z"
                                             fill="white" />
                                            </svg>
                                              Confirmer
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #publier>
    <!-- <div class="modal fade" tabindex="-1" id="publier"> -->
        <!-- <div class="modal-dialog modal-dialog-centered"> -->
            <div class="modal-content" tabindex="-1" id="publier">  
                <div class="modal-header">
                    <h3 class="modal-title">Assigner un test pour cette offre d'emploi</h3>

                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" (click)="closeModalAndRedirect()">
                        <i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="message mb-5">
                        <span>Après publier cette offre d'emploi, Voulez-vous ajouter un test?</span>
                    </div>
                    <div class="choice">
                        <div class="form-check form-check-custom form-check-solid">
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [(ngModel)]="addScale"
                                (change)="onAddScaleChange()" 
                                id="flexCheckDefault1"
                                [disabled]="addTestChecked ||addScaleAndTest || !subscriptionCanAccess('Barème')" 
                            />
                            <label class="form-check-label" for="flexCheckDefault1" 
                            [ngbTooltip]="!subscriptionCanAccess('Barème') ? 'Votre abonnement n’inclut pas cette fonctionnalité.' : null"
                            >
                                <span>Ajouter un barème</span>
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid">
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [(ngModel)]="addTestChecked"
                                (change)="onAddTestChange()" 
                                id="flexCheckDefault2"
                                [disabled]="addScale || addComp || addScaleAndTest"
                            />
                            <label class="form-check-label" for="flexCheckDefault2">
                                <span>Ajouter un test de compétence</span>
                            </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid"
                        >
                            <input 
                                class="form-check-input" 
                                type="checkbox" 
                                [(ngModel)]="addScaleAndTest"
                                (change)="onAddTestChange()" 
                                id="flexCheckDefault3"
                                [disabled]="addComp || addTestChecked|| addScale || !subscriptionCanAccess('Barème')"
                            />
                            <label class="form-check-label" for="flexCheckDefault3"
                            [ngbTooltip]="!subscriptionCanAccess('Barème') ? 'Votre abonnement n’inclut pas cette fonctionnalité.' : null"
                            >
                                <span>Ajouter un barème et un test de compétence </span>
                            </label>
                        </div>
                        
                    </div>
                    <div class="tests" *ngIf="addTestChecked">
                        <div class="form-check form-check-custom form-check-solid">
                          <input 
                            class="form-check-input" 
                            type="radio" 
                            [(ngModel)]="selectedTest" 
                            id="flexRadioDefault1" 
                            [value]="'wegestu'" 
                            (change)="onTestChange()"
                            name="testOptions"
                          />
                          <label class="form-check-label" for="flexRadioDefault1">
                            Test WeGestU
                          </label>
                        </div>
                        <div class="form-check form-check-custom form-check-solid">
                          <input 
                            class="form-check-input" 
                            type="radio" 
                            [(ngModel)]="selectedTest" 
                            id="flexRadioDefault2" 
                            [value]="'test'"
                            (change)="onTestChange()"
                            name="testOptions"
                          />
                          <label class="form-check-label" for="flexRadioDefault2">
                            Test Entreprise
                          </label>
                        </div>
                      </div>
                      
                </div>
                <div class="modal-footer">
                
                        <button type="button"(click)="closeModalAndRedirect()" class="btn btn-light">Annuler</button>
                   <button type="button"
                            [disabled]="!addTest && !addTestWegestU && !addTestChecked && !addScale && !addScaleAndTest"
                            class="btn btn-primary" (click)="onConfirm(jobId)">Confirmer</button>
                </div>
            </div>
        <!-- </div> -->
    <!-- </div> -->
</ng-template>